/* AOD — front-end scripts. Real Shopify AJAX cart, no fake data. */
(function () {
  'use strict';

  // ---- Sticky nav ------------------------------------------
  var nav = document.getElementById('navbar');
  if (nav) {
    var setScrolled = function () {
      if (window.scrollY > 40) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', setScrolled, { passive: true });
    setScrolled();
  }

  // ---- Mobile menu toggle ----------------------------------
  window.toggleMenu = function () {
    var navLinks = document.getElementById('navLinks');
    var toggle = document.getElementById('menuToggle');
    if (!navLinks) return;
    var open = navLinks.classList.toggle('is-open');
    if (toggle) {
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  // ---- Reveal on scroll -----------------------------------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.classList.add('visible'); // legacy class
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---- Cart drawer ----------------------------------------
  window.toggleCart = function () {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer || !overlay) return;
    var open = drawer.classList.toggle('is-open');
    overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  function fmtMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.moneyFormat);
    var v = (cents / 100).toFixed(2);
    return v + ' ' + (window.moneyFormat || '').replace(/\{\{.*?\}\}/, '').trim();
  }

  function renderCart(cart) {
    var itemsEl = document.getElementById('cartItems');
    var countEl = document.getElementById('cartCount');
    var subtotalEl = document.getElementById('cartSubtotal');
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty. Start building your kit.</p>';
      return;
    }
    var html = cart.items.map(function (item) {
      return [
        '<div class="cart-item" data-line="', (cart.items.indexOf(item) + 1), '">',
          '<div class="cart-item-image">',
            item.image ? '<img src="' + item.image + '&width=200" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" width="80" height="80">' : '',
          '</div>',
          '<div class="cart-item-details">',
            '<h4>', item.product_title, '</h4>',
            item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + item.variant_title + '</p>' : '',
            '<div class="cart-item-qty">',
              '<button class="qty-btn" type="button" data-cart-update data-key="', item.key, '" data-qty="', Math.max(0, item.quantity - 1), '" aria-label="Decrease">-</button>',
              '<span>', item.quantity, '</span>',
              '<button class="qty-btn" type="button" data-cart-update data-key="', item.key, '" data-qty="', item.quantity + 1, '" aria-label="Increase">+</button>',
              '<button class="qty-btn" type="button" data-cart-update data-key="', item.key, '" data-qty="0" aria-label="Remove" style="margin-left:0.5rem;">&times;</button>',
            '</div>',
            '<div class="cart-item-price">', fmtMoney(item.final_line_price), '</div>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');
    itemsEl.innerHTML = html;
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function updateCart(key, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // Delegate clicks for cart line updates
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-update]');
    if (!btn) return;
    e.preventDefault();
    updateCart(btn.dataset.key, parseInt(btn.dataset.qty, 10));
  });

  // Intercept product-form submits → AJAX add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Adding…'; }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          alert(data.description || data.message || 'Could not add to cart.');
          return;
        }
        return fetchCart().then(function () {
          if (submitBtn) { submitBtn.innerHTML = 'Added'; setTimeout(function () { submitBtn.innerHTML = originalText; submitBtn.disabled = false; }, 1200); }
          window.toggleCart();
        });
      })
      .catch(function () {
        alert('Network error.');
        if (submitBtn) { submitBtn.innerHTML = originalText; submitBtn.disabled = false; }
      });
  });

  // Variant select sync (size buttons → hidden select)
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.size-btn');
    if (!sizeBtn) return;
    var form = sizeBtn.closest('form');
    if (!form) return;
    var select = form.querySelector('.product-variants-select');
    if (!select) return;
    // Build option state from currently-active buttons
    var optionGroups = form.querySelectorAll('.modal-options');
    var selectedValues = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.size-btn.active');
      if (active) selectedValues.push(active.dataset.optionValue);
    });
    // Match against <option> labels
    Array.from(select.options).forEach(function (opt) {
      var match = selectedValues.every(function (v) { return opt.textContent.indexOf(v) !== -1; });
      if (match && !opt.disabled) { select.value = opt.value; }
    });
  });

  // ESC closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = document.getElementById('cartDrawer');
      if (drawer && drawer.classList.contains('is-open')) window.toggleCart();
    }
  });

  // ---- AOD Slider -----------------------------------------
  document.querySelectorAll('.aod-slider').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = slider.querySelectorAll('[data-slide]');
    var dots = slider.querySelectorAll('[data-slider-dot]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track || slides.length < 2) return;
    var index = 0;
    var auto = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval, 10) || 6000;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }
    function start() { if (auto) timer = setInterval(function () { go(index + 1); }, interval); }
    function stop() { clearInterval(timer); }

    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); start(); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { stop(); go(k); start(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    // Touch swipe
    var sx = 0;
    slider.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { stop(); go(dx < 0 ? index + 1 : index - 1); start(); }
    });
    start();
  });

  // ---- Initial cart fetch on load -------------------------
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().catch(function () {});
  });
})();
